import React from 'react'
import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from '@material-ui/core'

export const DialogComponent = ({ open, title = '', children, options = [], onClose, loading = false }) => {
  return (
    <div>
      <Dialog
        open={open || false}
        onClose={() => onClose(0)}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          {children}
        </DialogContent>
        <DialogActions>
          {options.map((option, i) => (
            <Button disabled={loading} key={i} onClick={() => onClose(i + 1)} color="primary" variant='contained'>
              {option}
            </Button>
          ))}
          <Button disabled={loading} onClick={() => onClose(0)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
